<template>
  <div class="my-header" data-automation="myHeader">
    <div class="my-header-left">
      <div class="my-header-logo"></div>
      <span class="my-header-line"></span>
      <div class="my-header-text">{{ $t('HT.header.heyTrack') }}</div>
      <!-- 收缩按钮 -->
      <div v-if="showCollapse" class="btn-collapse-box">
        <ux-button text class="btn-collapse" :icon="collapseIcon" @click="switchMenu"></ux-button>
      </div>
      <!-- 返回控制台 -->
      <router-link to="/home" v-if="showGoHome">
        <ux-button type="primary" text>{{ $t('HT.goBackConsole') }}</ux-button>
      </router-link>
    </div>
    <div class="my-header-right">
      <template v-if="isShowWorkOrder">
        <!-- 工单 -->
        <router-link to="/workOrder" :target="isWorkOrderModule ? '_self' : '_blank'">
          <ux-button class="btn-work-order" text @click="onClickWorkOrder">
            <ux-badge :is-dot="hasNoread">{{ $t('HT.workOrder') }}</ux-badge>
          </ux-button>
        </router-link>

        <span class="my-header-right-line"></span>
      </template>

      <!-- 语言选择 -->
      <ux-select
        class="my-header-lang"
        v-model="lang"
        :options="langOption"
        @change="onchangeLang"
      ></ux-select>
      <!-- 用户信息 -->
      <upper-user v-if="showUserName" :data="userData" @close="logout"></upper-user>
      <!-- 头像 -->
      <div v-if="showHeadImg" class="my-header-img"></div>
    </div>
  </div>
</template>

<script>
import upperUser from '@/views/template/upperUser';
// import options from '@l/options.js'; // 各种选项配置文件
// import Vue from 'vue';

export default {
  name: 'MyHeader',

  components: {
    upperUser
  },
  props: {
    // 显示头像
    showHeadImg: {
      type: Boolean,
      default: false
    },
    // 显示返回控制台
    showGoHome: {
      type: Boolean,
      default: false
    },
    // 显示返回工单
    showWorkOrder: {
      type: Boolean,
      default: false
    },
    // 显示用户信息
    showUserName: {
      type: Boolean,
      default: false
    },
    showCollapse: {
      type: Boolean,
      default: false
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lang: this.$cookie.get('locale'),
      langOption: [
        { label: '中文', value: 'zh' },
        { label: 'English', value: 'en' }
      ],
      hasNoread: false
    };
  },
  computed: {
    collapseIcon() {
      return this.isCollapse ? 'ux_icon_open' : 'ux_icon_shrink';
    },
    userData() {
      return this.$store?.state?.login?.userData || {};
    },
    isShowWorkOrder() {
      return (
        this.showWorkOrder &&
        this.$store.state.login.menuData.some((item) => Number(item.id) === 53)
      );
    },
    // 工单模块
    isWorkOrderModule() {
      return this.$route?.meta?.isWorkOrderModule;
    }
  },
  created() {
    if (this.showWorkOrder) {
      // this.checkStatus();
    }
  },
  methods: {
    logout() {
      this.$api.login.logout();
      this.$store.commit('logout');
      this.$router.push('/login');
      this.$uxModal.hide();
    },
    onClickWorkOrder() {
      if (this.isWorkOrderModule) {
        window.location.reload();
      }
    },
    // 点击收缩按钮
    switchMenu() {
      this.$emit('switch-menu');
    },
    // 查询是否有未读工单
    checkStatus() {
      this.$api.workOrder
        .checkStatus({ userId: this.userData.id }, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.hasNoread = String(res.data) === '0';
          }
        });
    },
    // 修改语言
    async onchangeLang(val) {
      this.$cookie.set('locale', val);
      window.location.reload();
      // await this.$loadLanguageAsync(val);
      // Vue.prototype.$opt = options(); // 更新下拉框的数据
    }
  }
};
</script>

<style lang="scss" scoped>
.my-header {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;

  .my-header-left {
    display: flex;
    align-items: center;
    overflow: hidden;

    .btn-collapse-box {
      display: flex;
      align-items: center;
      justify-content: center;
      background: $color-bg-disable;
      width: 24px;
      height: 24px;
    }
    .btn-collapse {
      font-size: 16px;
    }

    .my-header-line {
      width: 1px;
      height: 16px;
      background: $color-text-disable;
      margin: 0 16px;
    }

    .my-header-logo {
      display: block;
      width: 132px;
      height: 28px;
      background: url('~@/assets/images/web/logo.png') no-repeat center center / auto 100%;
      margin-left: 24px;
    }

    .my-header-text {
      color: $color-title;
      font-size: 18px;
      margin-right: 20px;
      font-weight: 600;
    }
  }

  .my-header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;
    padding-right: 40px;

    .my-header-right-line {
      width: 1px;
      height: 16px;
      background: $color-text-disable;
    }

    .btn-work-order {
      color: $color-text;
      padding-right: 20px;
      height: 24px;
      line-height: 24px;
      font-size: 14px;
    }

    ::v-deep .my-header-lang {
      min-width: 80px;
      max-width: 120px;

      .el-input {
        height: 24px;
        min-height: 24px;

        .el-input__inner {
          height: 24px !important;
          line-height: 24px;
          font-size: 14px;
          color: $color-text;
          border-color: transparent;
          background: transparent;
          padding-left: 20px;
        }
      }

      .el-input__icon {
        line-height: 24px;
      }
    }

    .my-header-img {
      margin-left: 6px;
      display: block;
      width: 24px;
      height: 24px;
      background: $color-bg-disable;
      border-radius: 12px;
      border: 1px solid $color-disable;
    }
  }
}
</style>
